import { RemoteGetAllProfessions } from 'data/usecases';
import { GetAllProfessionsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllProfessions =
  (): GetAllProfessionsUseCaseInterface =>
    new RemoteGetAllProfessions(makeApiUrlProfessions(), makeAxiosHttpClient());
